import { useEffect, useRef, useState } from "react";
import TempleView from "../../Views/Temple/TempleView";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ParentView from "../../Views/PrarentView/ParentView";
import { getTempleAndPujaList } from "../../store/actions/templeAction";
import {
  getDeviceTypeFromUserAgent,
  trackCleavertapEvent,
} from "../../utils/analyics/analyticsHelper";
import { ANALYTICS_EVENTS } from "../../utils/analyics/analyticsEvents";
import { LOCALSTORAGE_KEY } from "../../utils/Constants";
import useDebouncedCallback from "../../hooks/useDebouncedCallback";
import { pageReady } from "../../store/slices/pageViewSlice";
function TempleScreen() {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { cartInfo } = useSelector((state: any) => state.cart);
  const { allTempleList } = useSelector((state: any) => state.temple);
  const [templeList, setTempleList]: any = useState([]);
  const [listToshow, setListToShow]: any = useState([]);
  const lastLocalCommittedQueryRef = useRef<string>("");

  const listingViewedRef = useRef<boolean>(false);

  useEffect(() => {
    async function fetchTempleData() {
      try {
        dispatch(getTempleAndPujaList());
      } catch (error) {}
    }
    fetchTempleData();
  }, []);

  useEffect(() => {
    if (allTempleList && allTempleList.length) {
      makeLisIndexForSearch(allTempleList);
    }
    const trackPageViewEvent = (allTempleList: any) => {
      if (!allTempleList) return;
      if (listingViewedRef.current) return;
      listingViewedRef.current = true;
      dispatch(
        pageReady({
          User_ID:
            JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY.USERINFO) ?? "{}")
              ?.id ?? "Guest User",
          Page_Type: "Temple Listing",
          Listing_Type: "Temple Listing",
          Total_Items_Shown: allTempleList?.length ?? 0,
          Device_Type: getDeviceTypeFromUserAgent(),
        }),
      );
    };

    trackPageViewEvent(allTempleList);
  }, [allTempleList]);

  const makeLisIndexForSearch = (allTempleList: any) => {
    let finalList: any = [];
    for (let i = 0; i < allTempleList.length; i++) {
      let searchString = "";

      const templeName = allTempleList[i]?.personalInfo.name;
      const templeAddress =
        allTempleList[i]?.personalInfo?.address?.formatted_address;
      searchString = templeName + templeAddress;
      finalList = [
        ...finalList,
        { ...allTempleList[i], searchString: searchString },
      ];
    }
    setTempleList(finalList);
    setListToShow(finalList);
  };

  const searchTempleForUser = useDebouncedCallback((searchInput: string) => {
    if (!searchInput?.trim()) {
      setListToShow([]);
      return;
    }
    const userInputLC = searchInput.toLowerCase();
    let visibleList: any = [];

    for (let i = 0; i < templeList.length; i++) {
      const searchStrinLC =
        templeList[i] && templeList[i].searchString
          ? templeList[i].searchString.toLowerCase()
          : "";

      if (searchStrinLC.includes(userInputLC)) {
        visibleList = [...visibleList, templeList[i]];
      }
    }
    const currQuery = searchInput.trim();
    const prevQuery = lastLocalCommittedQueryRef.current;
    let isRefinement = false;

    if (prevQuery) {
      isRefinement =
        currQuery.startsWith(prevQuery) || prevQuery.startsWith(currQuery);
    }
    if (lastLocalCommittedQueryRef.current === currQuery) return;
    lastLocalCommittedQueryRef.current = currQuery;
    trackCleavertapEvent(ANALYTICS_EVENTS.Search_Performed, {
      User_ID:
        JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY.USERINFO) ?? "{}")
          ?.id ?? "Guest User",
      Search_Query: currQuery,
      Search_Type: "Temple Search",
      Search_Category: "Temple",
      Results_Count: visibleList?.length ?? 0,
      Search_Refinement: isRefinement,
    });
    setListToShow(visibleList);
  }, 500);

  const selectTemple = (templeDetails: any) => {
    navigate("/templeInfo?templeNameKey=" + templeDetails.nameKey);
  };
  return (
    <ParentView>
      <TempleView
        templeList={listToshow}
        searchTempleForUser={searchTempleForUser}
        selectTemple={selectTemple}
        cartDetails={cartInfo}
      />
    </ParentView>
  );
}

export default TempleScreen;
